import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
import React from "react";
import useBoolean from "@/common/hooks/useBoolean";
import MenuDotsIcon from "@/pages/sell-trade-v2/sell-trade/icons/MenuDotsIcon";
import CarSaleInfoBox from "@/components/CarSaleInfoBox/CarSaleInfoBox";
import CancelConfirmation from "@/pages/sell-my-car/components/CancelConfirmation";
import CancelReasonsModal from "@/pages/sell-my-car/components/CancelReasonsModal";
import SupportModal from "@/pages/sell-my-car/components/SupportModal";
import MenuActionsModal from "@/pages/sell-my-car/components/MenuActionsModal";
import CancelNotAllowedModal from "./CancelNotAllowedModal";
import StatusBadge from "./StatusBadge";
import CarInfo from "./CarInfo";
import rejectReasons from "@data/lookups/erp_cancel_reason.json";
import { cancelOrder } from "@/pages/sell-trade-v2/api/GetSellTradeList";
import { useTranslation } from "@i18n";
import { trackEvents } from "@/common/events/events";
import { useLang } from "@/common/Contexts/LanguageContext";
import deleteIcon from "@/pages/sell-trade-v2/sell-trade/icons/delete.svg";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@componentsShared/DropdownMenu";
import useIsMobile from "@hooks/useIsMobile";
import { If } from "@componentsShared/Conditional/If";
import { toast } from "sonner";
import { SELL_TRADE_STATUS } from "@/pages/sell-trade-v2/sell-trade/constants";
var CarSaleCard = function CarSaleCard(_ref) {
  var sellTradeItem = _ref.sellTradeItem,
    _ref$selectedMenuValu = _ref.selectedMenuValue,
    selectedMenuValue = _ref$selectedMenuValu === void 0 ? "support" : _ref$selectedMenuValu,
    onBookAppointment = _ref.onBookAppointment,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    onRefetch = _ref.onRefetch;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var lang = useLang();
  var isMobile = useIsMobile();
  var isCancelDialogOpen = useBoolean(false);
  var isReasonsModalOpen = useBoolean(false);
  var isSupportModalOpen = useBoolean(false);
  var isMenuActionsModalOpen = useBoolean(false);
  var isCancelNotAllowedModalOpen = useBoolean(false);
  var cancelable = sellTradeItem === null || sellTradeItem === void 0 ? void 0 : sellTradeItem.cancelable;
  var actions = [].concat(_toConsumableArray(cancelable ? [{
    label: tShort("card/cancel_order", {
      ns: "sell_trade_landing"
    }),
    value: "cancel",
    icon: "material-symbols--scan-delete-outline-rounded",
    onClick: isCancelDialogOpen.setTrue
  }] : []), [{
    label: tShort("card/contact_support", {
      ns: "sell_trade_landing"
    }),
    value: "support",
    icon: "material-symbols--support-agent",
    onClick: isSupportModalOpen.setTrue
  }]);
  var handleCancelConfirm = function handleCancelConfirm() {
    // Close first dialog and open reasons modal
    isCancelDialogOpen.setFalse();
    isReasonsModalOpen.setTrue();
  };
  var handleCancelClose = function handleCancelClose() {
    isCancelDialogOpen.setFalse();
  };
  var handleReasonsModalClose = function handleReasonsModalClose() {
    isReasonsModalOpen.setFalse();
  };
  var handleSupportModalClose = function handleSupportModalClose() {
    isSupportModalOpen.setFalse();
  };
  var handleMenuActionsModalClose = function handleMenuActionsModalClose() {
    isMenuActionsModalOpen.setFalse();
  };
  var handleCancelNotAllowedModalClose = function handleCancelNotAllowedModalClose() {
    isCancelNotAllowedModalOpen.setFalse();
  };
  var onContactSupport = isSupportModalOpen.setTrue;
  var handleCancelSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(reasonId, note) {
      var _response$data, reason, cancellationReasonText, _sellTradeItem$make, _sellTradeItem$make2, _sellTradeItem$model, _sellTradeItem$model2, _sellTradeItem$data, _sellTradeItem$data2, noteToSend, response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            // Find the cancellation reason text
            reason = rejectReasons.find(function (r) {
              return r.cancellation_reason_id === reasonId;
            });
            cancellationReasonText = lang === "ar" ? reason === null || reason === void 0 ? void 0 : reason.cancellation_reason_name_arabic : reason === null || reason === void 0 ? void 0 : reason.cancellation_reason_name_english; // Track the cancellation event
            if (sellTradeItem.current_status.id == SELL_TRADE_STATUS.UNDER_INSPECTION) {
              trackEvents("inspection_appointment_cancel", {
                order_id: sellTradeItem.request_id || sellTradeItem.id,
                car_make: lang === "ar" ? (_sellTradeItem$make = sellTradeItem.make) === null || _sellTradeItem$make === void 0 ? void 0 : _sellTradeItem$make.name_ar : (_sellTradeItem$make2 = sellTradeItem.make) === null || _sellTradeItem$make2 === void 0 ? void 0 : _sellTradeItem$make2.name_en,
                car_model: lang === "ar" ? (_sellTradeItem$model = sellTradeItem.model) === null || _sellTradeItem$model === void 0 ? void 0 : _sellTradeItem$model.name_ar : (_sellTradeItem$model2 = sellTradeItem.model) === null || _sellTradeItem$model2 === void 0 ? void 0 : _sellTradeItem$model2.name_en,
                car_year: sellTradeItem.year,
                car_mileage_range: sellTradeItem.mileage_range || undefined,
                car_city: ((_sellTradeItem$data = sellTradeItem.data) === null || _sellTradeItem$data === void 0 ? void 0 : _sellTradeItem$data.location) || undefined,
                inspection_location: ((_sellTradeItem$data2 = sellTradeItem.data) === null || _sellTradeItem$data2 === void 0 ? void 0 : _sellTradeItem$data2.inspection_location_type) || undefined,
                cancellation_reason: cancellationReasonText || reasonId
              });
            } else {
              trackEvents("sell_car_request_cancel", {
                order_id: sellTradeItem.request_id || sellTradeItem.id,
                cancel_stage: "pending_booking",
                cancellation_reason: cancellationReasonText || reasonId
              });
            }
            noteToSend = reasonId === "-1" ? note : cancellationReasonText || "";
            _context.n = 1;
            return cancelOrder({
              request_id: sellTradeItem.request_id,
              cancellation_reason_id: parseInt(reasonId),
              note: noteToSend
            });
          case 1:
            response = _context.v;
            if (!((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.success) == false)) {
              _context.n = 2;
              break;
            }
            isReasonsModalOpen.setFalse();
            isCancelNotAllowedModalOpen.setTrue();
            return _context.a(2);
          case 2:
            // Close the modal on success
            isReasonsModalOpen.setFalse();

            // Refetch data to remove the canceled item
            onRefetch === null || onRefetch === void 0 ? void 0 : onRefetch();
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            toast.error(tShort("errors/something_went_wrong", {
              ns: "common"
            }), {
              position: "top-center"
            });
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 3]]);
    }));
    return function handleCancelSubmit(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  // Add null checks for sellTradeItem
  if (!sellTradeItem) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-".concat(sellTradeItem.request_id || sellTradeItem.id),
    className: "relative bg-white rounded-[12px] border-[1px] border-solid border-[#D6DFE9] md:shadow-lg p-4 md:px-8 md:py-4 max-w-5xl w-full md:min-w-[600px] min-w-[304px] min-h-[305px] md:min-h-[370px] flex-1 ".concat(className)
  }, /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-header-".concat(sellTradeItem.request_id || sellTradeItem.id),
    className: "flex items-start justify-between mb-6 gap-2"
  }, /*#__PURE__*/React.createElement(CarInfo, {
    sellTradeItem: sellTradeItem
  }), /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-status-menu-".concat(sellTradeItem.request_id || sellTradeItem.id),
    className: "flex items-center justify-end gap-1 shrink-0"
  }, /*#__PURE__*/React.createElement(StatusBadge, {
    currentStatus: sellTradeItem.current_status
  }), /*#__PURE__*/React.createElement(If, {
    condition: !isMobile
  }, /*#__PURE__*/React.createElement(DropdownMenu, null, /*#__PURE__*/React.createElement(DropdownMenuTrigger, {
    asChild: true
  }, /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-menu-trigger-".concat(sellTradeItem.request_id || sellTradeItem.id),
    className: "cursor-pointer"
  }, /*#__PURE__*/React.createElement(MenuDotsIcon, null))), /*#__PURE__*/React.createElement(DropdownMenuContent, {
    align: "start",
    className: "w-[280px]"
  }, actions.map(function (action) {
    return /*#__PURE__*/React.createElement(DropdownMenuItem, {
      key: action.value,
      icon: action.icon,
      onClick: action.onClick
    }, action.label);
  })))), /*#__PURE__*/React.createElement(If, {
    condition: isMobile
  }, /*#__PURE__*/React.createElement("div", {
    id: "car-sale-card-menu-trigger-mobile-".concat(sellTradeItem.request_id || sellTradeItem.id),
    className: "cursor-pointer",
    onClick: isMenuActionsModalOpen.setTrue
  }, /*#__PURE__*/React.createElement(MenuDotsIcon, null))))), /*#__PURE__*/React.createElement(CarSaleInfoBox, {
    sellTradeItem: sellTradeItem,
    onContactSupport: onContactSupport,
    onBookAppointment: onBookAppointment
  }), /*#__PURE__*/React.createElement(CancelConfirmation, {
    isOpen: isCancelDialogOpen.value,
    icon: deleteIcon,
    onClose: handleCancelClose,
    title: tShort("card/cancel_confirmation_title", {
      ns: "sell_trade_landing"
    }),
    description: tShort("card/cancel_confirmation_description", {
      ns: "sell_trade_landing"
    }),
    cancelButton: {
      text: tShort("modal/follow_up_application", {
        ns: "sell_trade_landing"
      }),
      variant: "primary",
      action: handleCancelClose
    },
    confirmButton: {
      text: tShort("modal/cancel_application", {
        ns: "sell_trade_landing"
      }),
      variant: "outline",
      action: handleCancelConfirm
    }
  }), /*#__PURE__*/React.createElement(CancelReasonsModal, {
    isOpen: isReasonsModalOpen.value,
    onClose: handleReasonsModalClose,
    onSubmit: handleCancelSubmit,
    reasons: rejectReasons
  }), /*#__PURE__*/React.createElement(SupportModal, {
    isOpen: isSupportModalOpen.value,
    onClose: handleSupportModalClose,
    page: "sell-trade"
  }), /*#__PURE__*/React.createElement(CancelNotAllowedModal, {
    isOpen: isCancelNotAllowedModalOpen.value,
    onClose: handleCancelNotAllowedModalClose,
    page: "sell-trade",
    post_id: sellTradeItem === null || sellTradeItem === void 0 ? void 0 : sellTradeItem.id
  }), /*#__PURE__*/React.createElement(If, {
    condition: isMobile
  }, /*#__PURE__*/React.createElement(MenuActionsModal, {
    isOpen: isMenuActionsModalOpen.value,
    onClose: handleMenuActionsModalClose,
    actions: actions,
    title: tShort("support/order_management", {
      ns: "sell_trade_landing"
    })
  })));
};
export default CarSaleCard;